import React from 'react';
import { LogOut, RefreshCw, ShieldAlert } from 'lucide-react';
import { Button } from '@/ui/primitives/Button';
import { useSettings } from '@/features/settings/contexts/SettingsContext';
import { cn, useTheme } from '@/ui/theme/ThemeContext';

interface NoAccessibleWorkspaceProps {
  onReload: () => void;
  onSignOut: () => void;
}

export const NoAccessibleWorkspace: React.FC<NoAccessibleWorkspaceProps> = ({
  onReload,
  onSignOut,
}) => {
  const { t } = useSettings();
  const { theme } = useTheme();

  return (
    <div className={cn('flex min-h-full items-center justify-center px-6 py-10', theme.bgPrimary)}>
      <section
        aria-labelledby="no-access-title"
        className={cn('w-full max-w-xl rounded-lg border p-6 shadow-sm', theme.bgSecondary, theme.borderPrimary)}
      >
        <div className="flex min-w-0 items-start gap-4">
          <div className={cn('flex h-10 w-10 shrink-0 items-center justify-center rounded-md', theme.accentYellow)}>
            <ShieldAlert className="h-5 w-5" aria-hidden="true" />
          </div>
          <div className="min-w-0">
            <h1 id="no-access-title" className={cn('text-xl font-semibold', theme.textPrimary)}>
              {t('Workspace setup needed')}
            </h1>
            <p className={cn('mt-2 text-sm leading-6', theme.textSecondary)}>
              {t('Your account is signed in, but no workspace views are available yet. Reload the session after access is granted or sign out and try another account.')}
            </p>
          </div>
        </div>

        <div className="mt-6 flex flex-wrap gap-3">
          <Button type="button" size="lg" onClick={onReload} leftIcon={<RefreshCw className="h-4 w-4" />}>
            {t('Reload session')}
          </Button>
          <Button type="button" size="lg" variant="outline" onClick={onSignOut} leftIcon={<LogOut className="h-4 w-4" />}>
            {t('Sign out')}
          </Button>
        </div>
      </section>
    </div>
  );
};
